/* eslint-disable prettier/prettier */
import React from 'react'
import { Global, css } from '@emotion/react'
import { IndexNameTypes, INITIAL_QUERY_SUGGESTIONS_ID } from './utils'

const getStyles = ({ sourcesConfiguration }) => {
  const pSourceIds = sourcesConfiguration
    .filter(s => s.indexName === IndexNameTypes.PRODUCTS)
    .map(s => s.indexId)

  // prettier-ignore
  const pSourceIdsSelector = pSourceIds.length ? `section[data-autocomplete-source-id="${pSourceIds.join('"] ul, section[data-autocomplete-source-id="')}"] ul` : ''

  return css`
    .aa-Panel {
      position: relative !important;
      top: unset !important;
      left: unset !important;
      right: unset !important;
      box-shadow: unset !important;
      border-radius: unset !important;
      margin: unset !important;
    }
    .aa-Panel--scrollable {
      max-height: unset !important;
      padding: 0px !important;
    }
    .aa-SourceHeader {
      margin: 0px !important;
    }
    .aa-SubmitIcon,
    .aa-LoadingIcon,
    .aa-ClearIcon {
      color: unset !important;
      fill: unset !important;
    }
    .aa-SubmitButton {
      padding-left: 16px !important;
      padding-right: 10px !important;
    }
    .aa-Form:focus-within {
      border-color: unset !important;
      box-shadow: unset !important;
    }
    .aa-Item {
      width: fit-content !important;
      padding: 0px !important;
      min-height: unset !important;
    }
    .aa-Item mark {
      background-color: unset !important;
      color: #00d1d2;
    }
    .aa-Item[aria-selected='true'] {
      background-color: unset !important;
    }
    .aa-Item button,
    #${INITIAL_QUERY_SUGGESTIONS_ID} button {
      padding-right: 10px;
      height: unset !important;
      text-align: left !important;
    }
    .aa-Item .q-truncate {
      white-space: unset !important;
    }
    .aa-GradientBottom {
      display: none !important;
    }

    // Set the products sources as horizontal list
    ${
      // prettier-ignore
      pSourceIdsSelector ? `${pSourceIdsSelector} {
        display: flex;
        overflow-x: auto;
        scrollbar-width: none;
        align-items: baseline;
        gap: 8px;
        padding-top: 20px
      }` : ''
    }
    @media (min-width: 480px) {
      ${
        // prettier-ignore
        pSourceIdsSelector ? `${pSourceIdsSelector} {
          gap: 40px
        }` : ''
      }
    }
  `
}

const AutocompleteCSSOverride = props => <Global styles={getStyles(props)} />

export default AutocompleteCSSOverride
